import { ModalProps } from 'antd';
import styled from 'styled-components';

import { boxShadows } from '~src/branding/boxShadow';

import { ModalBase } from './common';

const Modal = styled(ModalBase)<{ background?: string }>(({ background = 'inherit' }) => ({
  '.ant-modal-header': {
    background,
    borderBottom: 'none',
  },
  '.ant-modal-body': {
    background,
  },
  '.ant-modal-title': { textAlign: 'center' },
  '.ant-modal-content': {
    ...boxShadows.modal,
    padding: '16px',
  },
}));

type ModalBaseProps = ModalProps & {
  setVisible?: (visible: false) => void;
  background?: string;
  maxWidth?: string | number;
};

export const ModalNorlys = (props: ModalBaseProps) => {
  return <Modal {...props} />;
};
